import { render, staticRenderFns } from "./ServiceElderByGender.vue?vue&type=template&id=69574998&scoped=true&"
import script from "./ServiceElderByGender.vue?vue&type=script&lang=js&"
export * from "./ServiceElderByGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69574998",
  null
  
)

export default component.exports